const stringCircumcision = (str: string) => {
  return str?.length > 40 ? str.substr(0, 40) + '...' : str;
};

export default stringCircumcision;
